import log from '@/lib/logger';
import {useState} from "react";
import {OrderTime} from "@/models/order-time";
import ConfirmationDialog, {ConfirmationConfig} from "@/components/confirmation-dialog/confirmation-dialog";
import {formatDateString} from "@/lib/utils";

interface OrderTimeDeleteDialogProps {
    isOpen: boolean;
    orderTime: OrderTime | null;
    onConfirm: (orderTime: OrderTime) => Promise<void>;
    onCancel: () => void;
}

export function OrderTimeDeleteDialog({
    isOpen,
    orderTime,
    onConfirm,
    onCancel
}: OrderTimeDeleteDialogProps) {
    const [isDeleting, setIsDeleting] = useState(false);

    if (!orderTime) return null;

    const handleConfirm = async () => {
        setIsDeleting(true);
        try {
            await onConfirm(orderTime);
        } catch (error) {
            log.error("Failed to delete order time:", error);
        } finally {
            setIsDeleting(false);
        }
    };

    const config: ConfirmationConfig = {
        title: "orderDetail.times.delete.title",
        description: "orderDetail.times.delete.description",
        descriptionValues: {
            date: formatDateString(orderTime.date),
            startTime: orderTime.startTime,
            endTime: orderTime.endTime
        },
        cancelButton: {
            text: "orderDetail.times.delete.buttons.cancel",
            ariaLabel: "orderDetail.times.delete.buttons.cancel"
        },
        confirmButton: {
            text: isDeleting 
                ? "orderDetail.times.delete.buttons.deleting"
                : "orderDetail.times.delete.buttons.confirm",
            ariaLabel: "orderDetail.times.delete.buttons.confirm",
            color: "red"
        }
    };

    return (
        <ConfirmationDialog
            isOpen={isOpen}
            onConfirm={handleConfirm}
            onCancel={onCancel}
            config={config}
            entityId={orderTime.id}
            namespace="orders"
            testIdPrefix="delete-order-time"
        />
    );
}